import Button from '@mui/material/Button';

import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/config-global';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

export function SignInButton({ sx, ...other }) {
  const { t } = useTranslation('dashboard/login');
  return (
    <Button
      component={RouterLink}
      href={CONFIG.auth.redirectPath}
      variant="outlined"
      sx={sx}
      {...other}
    >
      {t('signIn')}
    </Button>
  );
}
